import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

import NumberUtils from 'helpers/numberUtils';

const numberUtils = new NumberUtils();

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    backgroundColor: 'white',
    display: 'flex',
    alignItems: 'center',
  },
  title: {
    fontSize: 20,
    textAlign: 'center',
    color: 'red',
    marginBottom: 15,
  },
  table: {
    width: '100%',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    padding: 5,
  },
  tableHeaderCell: {
    color: 'white',
    fontSize: 10,
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#E5E7EB',
    padding: 5,
  },
  typeColumn: {
    flex: 4,
    fontSize: 10,
  },
  carrierColumn: {
    flex: 2,
    fontSize: 10,
    textAlign: 'center',
  },
  limitColumn: {
    flex: 2,
    fontSize: 10,
    textAlign: 'center',
  },
  statusColumn: {
    flex: 1,
    fontSize: 10,
    textAlign: 'center',
  },
  includedText: {
    color: 'black',
  },
  excludedText: {
    color: 'red',
  },
  footnote: {
    fontSize: 8,
    marginTop: 15,
    fontStyle: 'italic',
    textAlign: 'center',
    maxWidth: '400px',
  },
});

const CoverageSummary = ({ coverages }) => {
  const coverageData = [
    {
      type: 'Auto Liability',
      limit: coverages?.al?.value ?? null,
      carrier: coverages?.al?.carrier,
      status: coverages?.al?.included,
    },
    {
      type: 'Automobile Physical Damage',
      limit: coverages?.apd?.value ?? null,
      carrier: coverages?.apd?.carrier,
      status: coverages?.apd?.included,
    },
    {
      type: 'Motor Truck Cargo',
      limit: coverages?.mtc?.value ?? null,
      carrier: coverages?.mtc?.carrier,
      status: coverages?.mtc?.included,
    },
    {
      type: 'Truckers General Liability',
      limit: coverages?.tgl?.value ?? null,
      carrier: coverages?.tgl?.carrier,
      status: coverages?.tgl?.included,
    },
    {
      type: 'Non-Trucking Liability',
      limit: coverages?.ntl?.value ?? null,
      carrier: coverages?.ntl?.carrier,
      status: coverages?.ntl?.included,
    },
    {
      type: 'Towing Labor and Storage',
      limit: coverages?.towingLaborStorage?.value,
      carrier: coverages?.towingLaborStorage?.carrier,
      status: coverages?.towingLaborStorage?.included,
    },
    {
      type: 'UIIA',
      limit: '',
      status: coverages?.UIIAintermodal?.included,
    },
    {
      type: 'Waiver of Subrogation',
      limit: '',
      status: coverages?.waiverSubrogation?.included,
    },
    {
      type: 'Primary and Non-Contributory for AL',
      limit: '',
      status: coverages?.primaryNoncontributoryAL?.included,
    },
    {
      type: 'Primary and Non-Contributory for TGL',
      limit: '',
      status: coverages?.primaryNoncontributoryTGL?.included,
    },
    {
      type: 'Trailer interchange',
      limit: '',
      status: coverages?.trailerInterchange?.included,
    },
    {
      type: 'Refrigeration Coverage',
      limit: '',
      status: coverages?.commoditiesRefrigeration?.included,
    },
  ];

  return (
    <>
      <Text style={styles.title}>Coverage Summary</Text>

      <View style={styles.table}>
        <View style={styles.tableHeader}>
          <Text style={[styles.tableHeaderCell, styles.typeColumn]}>
            Coverage Type
          </Text>
          <Text
            style={[styles.tableHeaderCell, styles.carrierColumn]}
          >
            Carrier
          </Text>
          <Text style={[styles.tableHeaderCell, styles.limitColumn]}>
            Limit
          </Text>
          <Text style={[styles.tableHeaderCell, styles.statusColumn]}>
            Status
          </Text>
        </View>

        {coverageData.map((coverage, index) => (
          <View style={styles.tableRow}>
            <Text style={styles.typeColumn}>{coverage.type}</Text>
            <Text style={styles.carrierColumn}>
              {coverage.carrier}
            </Text>
            <Text style={styles.limitColumn}>
              {numberUtils.formatToCurrency(coverage.limit)}
            </Text>
            <Text
              style={[
                styles.statusColumn,
                ...(coverage.status
                  ? [styles.includedText]
                  : [styles.excludedText]),
              ]}
            >
              {coverage.status ? 'Included' : 'Excluded'}
            </Text>
          </View>
        ))}
      </View>

      <Text style={styles.footnote}>
        Please note that all deductibles are assigned to a policy by
        Cover Whale. The only way to change deductibles is if the
        insured is required to by contract.
      </Text>
      <Text style={styles.footnote}>
        Also note that not all lines of coverage are available for
        each risk or in each state. Please refer to the latest product
        offerings to find available coverages.
      </Text>
    </>
  );
};

export default CoverageSummary;
